<template>
  <div :dir="direction"
       class="fixed bottom-0 left-0 w-full z-40 bg-secondary bg-opacity-95 text-white flex md:items-center items-end justify-center py-6 px-4 md:px-6 transform duration-500 ease-in"
       :class="{ 'translate-y-0 opacity-1': showBanner, 'translate-y-full opacity-0': !showBanner }"
  >
    <div>
      {{ content }}
      <a
        v-if="link && linkText"
        :href="link"
        :target="openInNewWindow ? '_blank' : '_self'"
        class="font-semibold whitespace-no-wrap"
      >
        {{ linkText }}
      </a>
    </div>

    <div class="flex ltr:pl-4 rtl:pr-4 md:ltr:pl-16 md:rtl:pr-16">
      <button class="btn btn-yellow btn-sm mt-auto sm:px-20 whitespace-no-wrap" @click="onAcceptCookies">
        {{ btnText }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      required: true
    },
    linkText: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    },
    btnText: {
      type: String,
      required: true
    },
    openInNewWindow: {
      type: Boolean,
      required: true
    },
    direction: {
      type: String,
      default: 'ltr'
    }
  },
  data() {
    return {
      showBanner: false
    }
  },
  mounted() {
    if (localStorage.getItem('accepted-cookie-policy') !== 'accepted') {
      setTimeout(() => {
        this.showBanner = true
      }, 1000)
    }
  },
  methods: {
    onAcceptCookies() {
      localStorage.setItem('accepted-cookie-policy', 'accepted')
      this.showBanner = false
    }
  }
}
</script>
